import { mapActions, mapGetters } from 'vuex'

export const surveyEntryMixin = {
  computed: {
    ...mapGetters(['GET_ACCOUNT_ID'])
  },
  mounted() {
    // The accountid that comes from query params takes precedence over the accountid in the store,
    // because it's a survey created in a franchisee (filial) and not in franchise (matriz)
    this.setSurveyAccountId(this.$route.query.accountId || this.GET_ACCOUNT_ID)
  },
  methods: {
    ...mapActions('survey', ['setSurveyAccountId']),

    redirectToError(error) {
      console.error('Error: ', error)
      const message = error.response.errors?.[0]?.message
      let type = ''
      switch (message) {
        case 'Unauthorized':
          type = 'unauthorized'
          break
        case 'Survey not found':
          type = 'not-found'
          break
        case 'Survey is not active':
          type = 'inactive'
          break
        case 'Survey is finalized':
          type = 'finalized'
          break
        case 'Survey is scheduled':
          type = 'scheduled'
          break
        case 'User already finished this survey':
          type = 'completed'
          break
        default:
          this.$router.push({ name: '404' })
          return
      }

      this.$router.push({ name: 'survey-information', query: { type } })
    }
  }
}

export default surveyEntryMixin
